package com.cybersoftsolution.cybersoftsolutionweb.components.carousel

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.cybersoftsolution.cybersoftsolutionweb.models.MyElement
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import kotlinx.browser.window
import org.jetbrains.compose.web.css.marginLeft
import org.jetbrains.compose.web.css.marginRight
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div


@Composable
inline fun <reified T: MyElement> InfiniteCarousel(
    modifier: Modifier = Modifier,
    id: String,
    items: List<T>,
    showIndicator: Boolean = true,
    crossinline content: @Composable (T) -> Unit
) {


    LaunchedEffect(Unit) {
        window.setTimeout({ //Importante el timeout

                js(";new Swiper(\".swiper\", {\n" +
//                        "      effect: \"fade\",\n"+
//                        "      effect: \"cube\",\n" +
//                        "      cubeEffect: {\n" +
//                        "        shadow: true,\n" +
//                        "        slideShadows: true,\n" +
//                        "        shadowOffset: 20,\n" +
//                        "        shadowScale: 0.94,\n" +
//                        "      },\n"+
//                        "effect: \"coverflow\",\n"+
//                        "      centeredSlides: true,\n" +
//                        "      slidesPerView: \"auto\",\n" +
//                        "      coverflowEffect: {\n" +
//                        "        rotate: 50,\n" +
//                        "        stretch: 0,\n" +
//                        "        depth: 100,\n" +
//                        "        modifier: 1,\n" +
//                        "        slideShadows: true,\n" +
//                        "      },"+
                        "      slidesPerView: 1,\n" +
                        "      spaceBetween: 5,\n" +
//                        "      centeredSlides: true,\n"+
//                        "      grid: {\n" +
//                        "        rows: 2,\n" +
//                        "      },"+
                        "      delay:1,\n" +
                        "      freeMode: false,\n" +
                        "      disableOnInteraction: false,\n" +
                        "      pauseOnMouseEnter: false,\n" +
                        "      loop: true,\n" +
                        "      grabCursor: true,\n"+
                        "      autoplay :true,\n" +
                        "      speed: 1000,\n" +
//                        "      speed: 1000,\n" +
//                        "      loopedSlides: 1,\n"+
                        "      pagination: {\n" +
                        "        el: \".swiper-pagination\",\n" +
                        "        dynamicBullets: true,\n" +
                        "        clickable: true,"+
                        "      },"+
                        "      breakpoints: {\n" +
                        "        \"@0.00\": {\n" +
                        "          slidesPerView: 1,\n" +
                        "          spaceBetween: 5,\n" +
                        "        },\n" +
                        "        \"@0.15\": {\n" +
                        "          slidesPerView: 2,\n" +
                        "          spaceBetween: 5,\n" +
                        "        },\n" +
                        "        \"@0.20\": {\n" +
                        "          slidesPerView: 2,\n" +
                        "          spaceBetween: 5,\n" +
                        "        },\n" +
                        "        \"@0.35\": {\n" +
                        "          slidesPerView: 3,\n" +
                        "          spaceBetween: 2,\n" +
                        "        },\n" +
                        "        \"@0.50\": {\n" +
                        "          slidesPerView: 3,\n" +
                        "          spaceBetween: 2,\n" +
                        "        },\n" +
                        "        \"@0.60\": {\n" +
                        "          slidesPerView: 4,\n" +
                        "          spaceBetween: 5,\n" +
                        "        },\n" +
                        "        \"@0.75\": {\n" +
                        "          slidesPerView: 4,\n" +
                        "          spaceBetween: 5,\n" +
                        "        },\n" +
                        "        \"@1.00\": {\n" +
                        "          slidesPerView: 5,\n" +
                        "          spaceBetween: 5\n" +
                        "        },\n" +
                        "        \"@1.25\": {\n" +
                        "          slidesPerView: 6,\n" +
                        "          spaceBetween: 5,\n" +
                        "        },"+
                        "        \"@1.50\": {\n" +
                        "          slidesPerView: 7,\n" +
                        "          spaceBetween: 5,\n" +
                        "        },"+
                        "        \"@1.75\": {\n" +
                        "          slidesPerView: 8,\n" +
                        "          spaceBetween: 5,\n" +
                        "        },"+
                        "        \"@2.00\": {\n" +
                        "          slidesPerView: 9,\n" +
                        "          spaceBetween: 5,\n" +
                        "        },"+
//                        "        100: {\n" +
//                        "          slidesPerView: 1,\n" +
//                        "          spaceBetween: 0,\n" +
//                        "        },\n" +
//                        "        200: {\n" +
//                        "          slidesPerView: 2,\n" +
//                        "          spaceBetween: 0,\n" +
//                        "        },\n" +
//                        "        300: {\n" +
//                        "          slidesPerView: 3,\n" +
//                        "          spaceBetween: 0,\n" +
//                        "        },\n" +
//                        "        400: {\n" +
//                        "          slidesPerView: 3,\n" +
//                        "          spaceBetween: 0,\n" +
//                        "        },\n" +
//                        "        500: {\n" +
//                        "          slidesPerView: 4,\n" +
//                        "          spaceBetween: 0,\n" +
//                        "        },\n" +
//                        "        600: {\n" +
//                        "          slidesPerView: 5,\n" +
//                        "          spaceBetween: 0,\n" +
//                        "        },\n" +
//                        "        700: {\n" +
//                        "          slidesPerView: 5,\n" +
//                        "          spaceBetween: 0,\n" +
//                        "        },\n" +
//                        "        800: {\n" +
//                        "          slidesPerView: 6,\n" +
//                        "          spaceBetween: 0,\n" +
//                        "        },\n" +
//                        "        900: {\n" +
//                        "          slidesPerView: 6,\n" +
//                        "          spaceBetween: 0,\n" +
//                        "        },\n" +
//                        "        1000: {\n" +
//                        "          slidesPerView: 6,\n" +
//                        "          spaceBetween: 0,\n" +
//                        "        },\n" +
//                        "        1100: {\n" +
//                        "          slidesPerView: 7,\n" +
//                        "          spaceBetween: 0,\n" +
//                        "        },\n" +
//                        "        1200: {\n" +
//                        "          slidesPerView: 7,\n" +
//                        "          spaceBetween: 0,\n" +
//                        "        },\n" +
//                        "        1300: {\n" +
//                        "          slidesPerView: 7,\n" +
//                        "          spaceBetween: 0,\n" +
//                        "        },\n" +
//                        "        1400: {\n" +
//                        "          slidesPerView: 8,\n" +
//                        "          spaceBetween: 0,\n" +
//                        "        },\n" +


                        "      },\n" +
                        "    });") as Unit

        }, 0)
    }


    Div (
        attrs = modifier
            .id(id)
            .borderRadius(25.px)
//            .borderRadius(125.px)
            .classNames("swiper")
            .styleModifier {
                marginLeft((10).px)
                marginRight((10).px)
            }
            .toAttrs()
    ){
        if (showIndicator){
            Div (
                attrs = Modifier
                    .classNames("swiper-pagination")
                    .toAttrs()
            )
        }

        Div (
            attrs = Modifier
                .classNames("swiper-wrapper")
                .toAttrs()
        ){
            items.forEach { item ->
                Div (
                    attrs = Modifier
                        .classNames("swiper-slide")
                        .flexShrink(0)
                        .justifyContent(org.jetbrains.compose.web.css.JustifyContent.Center)
                        .padding(10.px)
                        .toAttrs()


                ){
                    content(item)
                }
            }
        }

    }



}

